import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d08377b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view profile" }
const _hoisted_2 = { class: "profile__header" }
const _hoisted_3 = { class: "profile__avatar" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "profile__avatar_text" }
const _hoisted_6 = { class: "profile__stats" }
const _hoisted_7 = { class: "profile__stat" }
const _hoisted_8 = { class: "profile__stat_amount" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile__stat_text" }, "Публикации", -1))
const _hoisted_10 = { class: "profile__buttons" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "profile__rewards"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile__rewards_title" }, "Награды:", -1))
const _hoisted_14 = { class: "profile__rewards_container" }
const _hoisted_15 = ["data-tooltip"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "profile__body" }

import { onBeforeMount, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';
import { toast } from 'vue3-toastify';
import { ProfileService, Profile } from '@/services/ProfileService';
import { WorksSevice, Works, WorkItem } from '@/services/WorksService';
import {
	Achievement,
	AchievementsService
} from '@/services/AchievementsService';
import BaseProfileCreation from '@/components/profile/BaseProfileCreation.vue';
import BaseLoader from '@/components/shared/BaseLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileUserView',
  setup(__props) {

const route = useRoute();

const profile: Ref<Profile | null> = ref(null);
const achievements: Ref<Achievement[] | null> = ref(null);
const images: Ref<Works<WorkItem> | null> = ref(null);

// TODO: separate component for ProfileView, ProfileUserView layout.

onBeforeMount(async () => {
	if (typeof route.query.id !== 'string') return;

	// Get profile
	ProfileService.getUserProfile(route.query.id).then(
		(_profile) => (profile.value = _profile)
	);

	// Get achievements
	AchievementsService.getUserAchievements(route.query.id).then(
		(_achievements) =>
			(achievements.value = _achievements.achievements ?? null)
	);

	// Get works/images
	WorksSevice.getUserWorks(route.query.id).then(
		(_images) => (images.value = _images)
	);
});

function shareProfile() {
	if (!profile.value) return;

	const shareLink = `https://app.burngram.com/#/profile/user?id=${profile.value.id}`;
	const shareData = {
		title: 'Burngram',
		text: `Профиль @${profile.value.nickname} на Burngram\n${shareLink}`
	};

	// Web Share API (only HTTPS, locally supported)
	if (navigator.share && navigator.canShare(shareData)) {
		navigator
			.share(shareData)
			.then(() => toast.info('Успешно поделились ссылкой'));
	}
	// Clipboard API
	else if (navigator.clipboard) {
		navigator.clipboard
			.writeText(shareLink)
			.then(() => toast.info('Ссылка скопирована'));
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (profile.value && images.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: profile.value.avatar,
                alt: profile.value.nickname,
                class: "profile__avatar_image"
              }, null, 8, _hoisted_4),
              _createElementVNode("p", _hoisted_5, "@" + _toDisplayString(profile.value.nickname), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(images.value.items.length ?? 0), 1),
                _hoisted_9
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _withModifiers(shareProfile, ["prevent"]),
                class: "button button-dark profile__buttons_button"
              }, " Поделиться ", 8, _hoisted_11)
            ]),
            (achievements.value && achievements.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(achievements.value, (achievement) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: achievement.id,
                        class: "profile__reward tooltip",
                        "data-tooltip": achievement.name
                      }, [
                        _createElementVNode("img", {
                          src: achievement.image_url,
                          alt: achievement.name
                        }, null, 8, _hoisted_16)
                      ], 8, _hoisted_15))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value.items, (work) => {
              return (_openBlock(), _createBlock(BaseProfileCreation, {
                id: work.id,
                key: work.id,
                image: work.image_url,
                date: work.created_at
              }, null, 8, ["id", "image", "date"]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
  ]))
}
}

})